import { XCircleIcon } from "@heroicons/react/24/outline";
import { Button } from "@babackapp/ui/components/button";
import useTranslation from "@babackapp/translations/use-translation";

interface VerificationErrorProps {
  error?: string;
  onResendVerification: () => void;
  onBackToSignIn: () => void;
}

export function VerificationError({ 
  error, 
  onResendVerification, 
  onBackToSignIn 
}: VerificationErrorProps) {
  const t = useTranslation();

  return (
    <div className="text-center">
      <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-6">
        <XCircleIcon className="h-8 w-8 text-red-600" aria-hidden="true" />
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-4">
        {t("verifyEmail.error.title")}
      </h3>
      <p className="text-sm text-gray-600 mb-4">
        {error || t("verifyEmail.error.description")}
      </p>
      <div className="space-y-3">
        <Button onClick={onResendVerification} variant="outline" className="w-full">
          {t("verifyEmail.error.resend")}
        </Button>
        <Button onClick={onBackToSignIn} className="w-full">
          {t("verifyEmail.error.backToSignIn")}
        </Button>
      </div>
    </div>
  );
}